module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '# Kinetics Implementation Notes\n\n- Basic kinetics is working relatively well; some issues with the temperature jump code, interaction with cooling, weird "blip" in concentrations - is there any good way to check and make sure this is working?\n- All of these things are updating too quickly - why are there so many issues with updating the temperature, vessels?\n- Perhaps the issue is caused by "Exceeded Maximum # of iterations: 300" issues?\n- Fixed! The problem was additional iterations causing the reaction to continue to "jump"\n\n- Should kinetics reactions respect the overall equilibrium constant (determined from H0, S0, etc)?\n';

}
return __p
}